var _defineProperty = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/defineProperty.js").default;

var _toConsumableArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/keycodes"] = t() : (e.wp = e.wp || {}, e.wp.keycodes = t());
}(self, function () {
  return function () {
    "use strict";

    var e = {
      729: function _(e, t, r) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isAppleOS = function isAppleOS() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;

          if (!e) {
            if ("undefined" == typeof window) return !1;
            e = window;
          }

          var t = e.navigator.platform;
          return -1 !== t.indexOf("Mac") || (0, o.includes)(["iPad", "iPhone"], t);
        };
        var o = r(793);
      },
      756: function _(e) {
        e.exports = require("@wordpress/i18n");
      },
      793: function _(e) {
        e.exports = require("lodash");
      }
    },
        t = {};

    function __webpack_require__(r) {
      var o = t[r];
      if (void 0 !== o) return o.exports;
      var i = t[r] = {
        exports: {}
      };
      return e[r](i, i.exports, __webpack_require__), i.exports;
    }

    var r = {};
    return function () {
      var e = r;
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.shortcutAriaLabel = e.rawShortcut = e.modifiers = e.isKeyboardEvent = e.displayShortcutList = e.displayShortcut = e.ZERO = e.UP = e.TAB = e.SPACE = e.SHIFT = e.RIGHT = e.PAGEUP = e.PAGEDOWN = e.LEFT = e.HOME = e.F10 = e.ESCAPE = e.ENTER = e.END = e.DOWN = e.DELETE = e.CTRL = e.COMMAND = e.BACKSPACE = e.ALT = void 0;

      var t = __webpack_require__(793),
          o = __webpack_require__(756),
          i = __webpack_require__(729);

      e.BACKSPACE = 8;
      e.TAB = 9;
      e.ENTER = 13;
      e.ESCAPE = 27;
      e.SPACE = 32;
      e.PAGEUP = 33;
      e.PAGEDOWN = 34;
      e.END = 35;
      e.HOME = 36;
      e.LEFT = 37;
      e.UP = 38;
      e.RIGHT = 39;
      e.DOWN = 40;
      e.DELETE = 46;
      e.F10 = 121;
      var n = "alt";
      e.ALT = n;
      var s = "ctrl";
      e.CTRL = s;
      var a = "meta";
      e.COMMAND = a;
      var l = "shift";
      e.SHIFT = l;
      e.ZERO = 48;
      var c = {
        primary: function primary(e) {
          return e() ? [a] : [s];
        },
        primaryShift: function primaryShift(e) {
          return e() ? [l, a] : [s, l];
        },
        primaryAlt: function primaryAlt(e) {
          return e() ? [n, a] : [s, n];
        },
        secondary: function secondary(e) {
          return e() ? [l, n, a] : [s, l, n];
        },
        access: function access(e) {
          return e() ? [s, n] : [l, n];
        },
        ctrl: function ctrl() {
          return [s];
        },
        alt: function alt() {
          return [n];
        },
        ctrlShift: function ctrlShift() {
          return [s, l];
        },
        shift: function shift() {
          return [l];
        },
        shiftAlt: function shiftAlt() {
          return [l, n];
        },
        undefined: function undefined() {
          return [];
        }
      };
      e.modifiers = c;
      var p = (0, t.mapValues)(c, function (e) {
        return function (t) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.isAppleOS;
          return [].concat(_toConsumableArray(e(r)), [t.toLowerCase()]).join("+");
        };
      });
      e.rawShortcut = p;
      var u = (0, t.mapValues)(c, function (e) {
        return function (r) {
          var _p;

          var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.isAppleOS;
          var c = o(),
              p = (_p = {}, _defineProperty(_p, n, c ? "⌥" : "Alt"), _defineProperty(_p, s, c ? "⌃" : "Ctrl"), _defineProperty(_p, a, "⌘"), _defineProperty(_p, l, c ? "⇧" : "Shift"), _p),
              u = e(o).reduce(function (e, r) {
            var o = (0, t.get)(p, r, r);
            return c ? [].concat(_toConsumableArray(e), [o]) : [].concat(_toConsumableArray(e), [o, "+"]);
          }, []),
              d = (0, t.capitalize)(r);
          return [].concat(_toConsumableArray(u), [d]);
        };
      });
      e.displayShortcutList = u;
      var d = (0, t.mapValues)(u, function (e) {
        return function (t) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.isAppleOS;
          return e(t, r).join("");
        };
      });
      e.displayShortcut = d;
      var f = (0, t.mapValues)(c, function (e) {
        return function (r) {
          var _u;

          var c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.isAppleOS;
          var p = c(),
              u = (_u = {}, _defineProperty(_u, l, "Shift"), _defineProperty(_u, a, p ? "Command" : "Control"), _defineProperty(_u, s, "Control"), _defineProperty(_u, n, p ? "Option" : "Alt"), _defineProperty(_u, ",", (0, o.__)("Comma")), _defineProperty(_u, ".", (0, o.__)("Period")), _defineProperty(_u, "`", (0, o.__)("Backtick")), _u);
          return [].concat(_toConsumableArray(e(c)), [r]).map(function (e) {
            return (0, t.capitalize)((0, t.get)(u, e, e));
          }).join(p ? " " : " + ");
        };
      });

      function getEventModifiers(e) {
        return [n, s, a, l].filter(function (t) {
          return e["".concat(t, "Key")];
        });
      }

      e.shortcutAriaLabel = f;

      var _ = (0, t.mapValues)(c, function (e) {
        return function (r, o) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.isAppleOS;
          var s = e(n),
              a = getEventModifiers(r);
          if ((0, t.xor)(s, a).length) return !1;
          var l = r.key.toLowerCase();
          return o ? (r.altKey && 1 === o.length && (l = String.fromCharCode(r.keyCode).toLowerCase()), "del" === o && (o = "delete"), l === o.toLowerCase()) : (0, t.includes)(s, l);
        };
      });

      e.isKeyboardEvent = _;
    }(), r;
  }();
});